import Api from '@/services/Api'

export default {
    getAllVigenciasCalificacion(){
        return Api().get('calificacion/getAllVigenciasCalificacion')
    },
    calificacionById(id){
        return Api().get('calificacion/calificacionById/'+id)
    },
    calificacionByVigencia(vigencia){
        return Api().get('calificacion/calificacionByVigencia/'+vigencia)
    },
    calificacionByVigenciaAndCalificacion(vigencia,calificacion){
        return Api().get('/calificacion/calificacionByVigenciaAndCalificacion/'+vigencia+'/'+calificacion)
    },
    createCalificacion(datos){
        return Api().post('calificacion/create',datos)
    },
    updateCalificacion(info){
        return Api().put('calificacion/update',info)
    }
    // updateTasaById(datos){
    //     return Api().put('tasa/update',datos)
    // },
    // deleteTasa(id){
    //     return Api().delete('tasa/delete/'+id)
    // }
}